import {Box} from "@mui/material";
import LoadoutDisplay from "./LoadoutDisplay";
import {useEffect, useState} from "react";
import {decodeLoadoutId} from "../WeaponBuilder";
import {useParams} from "react-router-dom";

function LoadoutCard({loadout, menuRef}) {

    const loadoutId = useParams().loadoutId

    const [weapon, setWeapon] = useState({})
    const [attachments, setAttachments] = useState({})

    useEffect(() => {
        const {loadoutWeapon, loadoutAttachments} = decodeLoadoutId(loadout ?? loadoutId);
        setWeapon(loadoutWeapon)
        setAttachments(loadoutAttachments)
    }, [loadoutId, loadout])

    return (
        <Box ref={menuRef} sx={{position: 'absolute', left: 0, top: 0, zIndex: -100, overflow: 'clip'}} width={1125} height={600}>
            {weapon?.name == null ? null :
                <LoadoutDisplay card weapon={weapon} attachments={attachments} type={'card'}/>
            }
        </Box>
    )
}

export default LoadoutCard